import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { AlertCircleIcon } from 'lucide-react';
interface Slide10Props {
  onNavigate: (slide: number) => void;
}
export function Slide10({
  onNavigate
}: Slide10Props) {
  return <SlideLayout footer="¹ Vabysmo® Summary of Product Characteristics (SmPC/RCP), May 2024." onBack={() => onNavigate(7)} data-id="element-44">
      <div className="w-full max-w-4xl mx-auto space-y-12" data-id="element-45">
        <h1 className="text-4xl font-bold text-primary text-center mb-8" data-id="element-46">
          Pregnancy considerations
        </h1>
        <div className="bg-white rounded-2xl shadow-xl p-12 border border-teal-100/50" data-id="element-47">
          <div className="flex items-start gap-6" data-id="element-48">
            <div className="flex-shrink-0" data-id="element-49">
              <div className="w-16 h-16 bg-accent rounded-full flex items-center justify-center" data-id="element-50">
                <AlertCircleIcon className="w-8 h-8 text-white" data-id="element-51" />
              </div>
            </div>
            <div className="flex-1" data-id="element-52">
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-53">
                Women of childbearing potential should use effective
                contraception during treatment and for 3 months after the last
                dose, as outlined in the SmPC.
                <sup data-id="element-54">¹</sup>
              </p>
            </div>
          </div>
        </div>
      </div>
    </SlideLayout>;
}